import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root"
})
export class FeatureFlagService {
  
  COMMON_ICMS_PROPS = ['SUBGROUP_TYPE','GROUP_TYPE','SET_NOTIFICATION','CONTENT_ID','NAME'];

  loadFeatureFlag(content: any, config: any): any {
    const featureConfig = config;
    const updatedContent = content;
    if (updatedContent && 'object' === typeof updatedContent) {
      Object.keys(updatedContent).forEach(k => {
        updatedContent[k] = this.parseData(updatedContent[k]);
      });

      if (featureConfig && 'object' === typeof featureConfig) {
        Object.keys(featureConfig).forEach(k => {
          if(!this.COMMON_ICMS_PROPS.includes(k)){
            featureConfig[k] = this.parseData(featureConfig[k]);
            updatedContent[k] = this.setContent(updatedContent[k], featureConfig[k]);
          }
        });
      }
    }
    return updatedContent;
  }

  private setContent(content: any, props: any) {
    if (props?.isConfigActive && new Date().getTime() - new Date(props.configStartDate).getTime() > 0) {
      this.updateObj(content, props);
    }
    return content;
  }

  private updateObj(targetObject, obj) {    
    for (const p in obj) {
      if(['isConfigActive','configStartDate'].includes(p)) continue;
      if ("object" === typeof obj[p] && "object" === typeof targetObject[p] && targetObject.hasOwnProperty(p)) {
        targetObject[p] = this.updateObj(targetObject[p], obj[p]);
      } else {
        targetObject[p] = obj[p];
      }
    }
    return targetObject;
  }

  private parseData(content: any) {
    let result = content;
    try {
      result = JSON.parse(content);
    } catch (e) {
      console.error("Invalid Json String!");
    }
    return result;
  }

}
